<template>
  <div class="wrapper" :class="{ print: prepareForPrint }">
    <div class="image" :class="{ print: prepareForPrint }">
      <img
        class="expandable-image"
        :src="confinedSpace.picture_url"
        alt="Imagem do espaço confinado"
        @click="showSingleImage(confinedSpace.picture_url)"
      />
    </div>
    <div class="image tag-image" :class="{ print: prepareForPrint }">
      <img
        class="expandable-image"
        :src="confinedSpace.ambra_tag_picture_url"
        alt="Imagem da tag"
        @click="showSingleImage(confined_space.ambra_tag_picture_url)"
      />
    </div>
    <div class="content border" :class="{ print: prepareForPrint }">
      <div class="row confined-space-details mb-3">
        <div class="col-4 col-md-4 confined-space-details__item">
          <b>Nome:</b> {{ confinedSpace?.name || '' }}
        </div>
        <div class="col-4 col-md-4 confined-space-details__item">
          <b>Tipo E.C.:</b> {{ confinedSpace?.confined_space_type?.name || '' }}
        </div>
        <div class="col-4 col-md-4 confined-space-details__item">
          <b>Tag E.C.:</b> {{ confinedSpace?.confined_space_tag || '' }}
        </div>
        <div class="col-4 col-md-4 confined-space-details__item">
          <b>Setor:</b> {{ confinedSpace?.company_sector?.name || '' }}
        </div>
        <div class="col-4 col-md-4 confined-space-details__item">
          <b>Área:</b> {{ confinedSpace?.company_area?.name || '' }}
        </div>
        <div class="col-4 col-md-4 confined-space-details__item">
          <b>Complemento:</b> {{ confinedSpace?.company_complement?.name || '' }}
        </div>
        <div class="col-4 col-md-4 confined-space-details__item">
          <b>Tag Ambra:</b> {{ confinedSpace?.ambra_tag || '' }}
        </div>
        <div class="col-4 col-md-4 confined-space-details__item">
          <b>Multa máxima prevista:</b>
          R$ {{ formatPrice(maxFine) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import useImageViewer from '@/modules/ImageViewer.js'

  export default {
    setup(props) {
      const { showSingleImage } = useImageViewer()

      return {
        showSingleImage,
      }
    },
    components: {

    },
    data() {
      return {
        images: [],
        imageIndex: 1,
        imageVisible: false,
      }
    },
    props: {
      confinedSpace: {
        type: Object,
        required: true,
      },
      maxFine: {
        type: Number,
        required: false,
        default: 0
      },
      prepareForPrint: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    methods: {
      formatPrice(value) {
        const val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
    }
  }
</script>

<style lang="scss" scoped>
  .confined-space-details {
    padding: 20px;

    &__item {
      margin-top: 10px;
    }
  }

  .wrapper {
    display: flex;
    min-height: 300px;

    &.print {
      min-height: 200px;
      font-size: 0.7rem;
    }
  }

  .content {
    flex-grow: 1;

    &.print {
      max-height: 200px;
    }
  }

  .image {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 150px;
    // height: 100%;
    border: 1px solid #ccc;
    margin-right: 5px;
    text-align: center;

    img {
      object-fit: cover;
      max-width: 100%;
      max-height: 100%;
    }

    &.print {
      max-height: 200px;
      width: auto;

      img {
        object-fit: cover;
        max-width: 100%;
        max-height: 200px;
      }
    }
  }

  .expandable-image {
    cursor: pointer;
  }
</style>
